var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowIcons1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.5L39.5 10",
    stroke: "#F2C641",
    strokeWidth: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 37.4215L40 38",
    stroke: "#F2C641",
    strokeWidth: 9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74022 19.1908L13 2",
    stroke: "#F2C641",
    strokeWidth: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowIcons1);
export default __webpack_public_path__ + "static/media/yellow-icons-1.66c791d8c35d7435c3d03486dafb970d.svg";
export { ForwardRef as ReactComponent };